import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a5e61a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Resuelve temas pendientes", -1))
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = { key: 0 }

import { onMounted, ref } from 'vue'
import LaterService from '@/services/LaterService'
import { useAuth } from '@/store/useAuth'
import LessonList from '@/components/cards/LessonList.vue'
import LessonService from '@/services/LessonService'
//import AdvertisementMain from '@/components/advertisement/AdevertisementMain.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LaterLessons',
  setup(__props) {

const store = useAuth()
const laterService = new LaterService()
const lessonService = new LessonService()
const allLessons = ref([])
const lessons = ref([])
const loading = ref(false)
const moreThan21 = ref(false)

onMounted(async () => {
    loading.value = true
    if (store.token) {
        allLessons.value = await laterService.getAllFromUser(store.token)
    }

    let counter = 0;
    allLessons.value.forEach(async lesson => {
        counter++
        if(counter <= 9 ) {
            const item = await lessonService.getLesson(lesson.lesson_id)
            lessons.value.push(item)
        }
        else {
            moreThan21.value = true
        }
    });
    Promise.all(lessons.value)
    loading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_icon, { name: "RiLoader2Fill" }),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_icon, { name: "RiLoader2Fill" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (lessons.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lessons.value, (item) => {
                    return (_openBlock(), _createBlock(LessonList, {
                      key: item.id,
                      content: item
                    }, null, 8, ["content"]))
                  }), 128)),
                  _hoisted_6
                ]),
                (moreThan21.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_RouterLink, { to: {name: 'my-laters'} }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver todos")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}
}

})